module.exports = __webpack_public_path__ + "assets/images/box/icon_min@2x.png";